{
    "Accessibility Menu": "Хандалтын цэс",
    "Reset settings": "Тохиргоог дахин тохируулах",
    "Close": "Хаах",
    "Content Adjustments": "Агуулгын тохируулга",
    "Adjust Font Size": "Фонтын хэмжээг тохируулах",
    "Highlight Title": "Гарчгийг онцлох",
    "Highlight Links": "Холбоосуудыг онцлох",
    "Readable Font": "Уншихад хялбар фонт",
    "Color Adjustments": "Өнгөний тохируулга",
    "Dark Contrast": "Харанхуй ялгарал",
    "Light Contrast": "Гэрэлтэй ялгарал",
    "High Contrast": "Өндөр ялгарал",
    "High Saturation": "Өндөр ханалт",
    "Low Saturation": "Бага ханалт",
    "Monochrome": "Нэг өнгө",
    "Tools": "Хэрэгслүүд",
    "Reading Guide": "Унших гарын авлага",
    "Stop Animations": "Анимацийг зогсоох",
    "Big Cursor": "Том курсор",
    "Increase Font Size": "Фонтын хэмжээг нэмэгдүүлэх",
    "Decrease Font Size": "Фонтын хэмжээг багасгах",
    "Letter Spacing": "Үсгийн хоорондын зай",
    "Line Height": "Мөрийн өндөр",
    "Font Weight": "Фонтын жин",
    "Dyslexia Font": "Дислекси фонт",
    "Language": "Хэл",
    "Open Accessibility Menu": "Хандалтын цэсийг нээх"
  }
  